import React from "react";
import { useTranslation } from "react-i18next";
import BrandNav from "../../components/BrandNav";

export default function RoboticsSignup() {
  const { t } = useTranslation();
  return (
    <>
      <BrandNav />
      <main className="ftg-page">
        <h1>{t("signup.title")}</h1>
      </main>
    </>
  );
}
